module.exports = __webpack_public_path__ + "static/media/ImgENG2.57c60a53.svg";